import React from 'react';
import { useSelector } from 'react-redux';
import { SelectedEventPanel } from './SelectedEventPanel';
import { getHeaderHeight, getMapOverlayTop, getSelectedEventPanelTop } from './mapLayout';

const sidePanelBaseStyle = {
    position:'absolute', 
    top:16, 
    right:0, 
    zIndex:99,
    display:'flex',
    flexDirection:'row',
    alignItems:'center'
}

export function SidePanel() {
    const appWidth= useSelector(state=>state.appWidth);
    const appHeight = useSelector(state=>state.appHeight);
    const hideHeader = useSelector(state=>state.hideHeader);
    const embed = useSelector(state=>state.embed);
    const headerHeight = getHeaderHeight(appWidth, hideHeader);
    const verticalGutter = getMapOverlayTop(appWidth);
    const showMapControls = !embed;
    const panelTop = getSelectedEventPanelTop(appWidth, showMapControls);

    const sidePanelStyle = {
        ...sidePanelBaseStyle,
        top: panelTop,
        height:(appHeight - headerHeight - panelTop - verticalGutter) + 'px',
    }

    return (
        <div style={sidePanelStyle}>
            <SelectedEventPanel/>
        </div>
    );
}
  
